module.exports = __webpack_public_path__ + "static/media/15UN-Habitat2.d799c0a6.jpg";